export const numbers= '0123456789'
export const upperCaseLetters='ABCDEFGHIJKLMNOPQRSTUVWXYZ'
export const specialCharacters="!@#$%^&/+()^[]{}><*_=:;"

export const lowerCaseLetters='abcdefghijklmnopqrstuvwxyz'